"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.frCountry = void 0;
var _companyNumber = require("../../companyNumber");
var _utils = require("../utils");
// i18next-extract-mark-ns-start Countries

var frCountry = exports.frCountry = function frCountry(t) {
  return {
    id: 'FR',
    name: t('France'),
    flag: '🇫🇷',
    zipcodeChecker: function zipcodeChecker(zipcode) {
      var regex = /^[0-9]{5}$/;
      return regex.test(zipcode);
    },
    zipcodeMatcher: _utils.defaultZipcodeMatcher,
    zipcodePlaceholder: '75001 or 69008',
    phonePrefix: '33',
    phoneLength: 9,
    pricingVersion: 13,
    timezone: 'Europe/Paris',
    currency: 'EUR',
    companyNumber: {
      label: _companyNumber.labels.FR,
      checker: _companyNumber.checkers.FR,
      placeholder: '82503893800031'
    }
  };
};